import React from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faAward } from '@fortawesome/free-solid-svg-icons';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { injectStripe } from 'react-stripe-elements';
import withI18next from '~/../hocs/_withI18next';
import Link from '~/components/I18nLink';
import Config from '~/config';
import { locales } from '~/utils';
import { formatFloatNumber } from '~/utils/formatter';

const renderRadioField = ({ input, name, type, id, value, temp }) => (
  <input type={type} name={name} id={id} value={temp} {...input} />
);

const renderCheckboxField = ({ input, placeholder, type, title }) => (
  <label style={{ marginTop: 5, paddingRight: 5 }}>
    <input type={type} {...input} />
    <b style={{ borderRadius: 2 }} /> {title}
  </label>
);

@withI18next()
class ExtraLicenseRegisterForm extends React.Component {
  buildExtraLicensePlan = (plan, isDefault) => {
    const { lng } = this.props;
    const currentPlanByLang = plan.prices.filter((item) => item.lang == lng);

    return {
      idPlan: plan.id,
      numberOfLicense: plan.number_license,
      currentPlanByLang: currentPlanByLang[0],
      isDefault,
    };
  };

  renderExtraPlanItem = (planItem, index) => {
    const price = formatFloatNumber(
      locales.roundPriceByCurrency(
        planItem.currentPlanByLang.unit,
        planItem.currentPlanByLang.price,
      ),
    );
    const pricePerImage = formatFloatNumber(
      locales.roundPriceByCurrency(
        planItem.currentPlanByLang.unit,
        planItem.currentPlanByLang.price / planItem.numberOfLicense,
      ),
    );

    return (
      <>
        <Field
          type="radio"
          name="selected_plan"
          id={`option${index}`}
          component="input"
          value={`${planItem.idPlan}`}
        />
        <label
          htmlFor={`option${index}`}
          className={`subscription__button ${Config.serviceType}`}
        >
          <h3 className={`subscription__title ${Config.serviceType}`}>
            <span>
              {planItem.numberOfLicense}
              &nbsp;
              {this.props.t('images')}
              &nbsp;-&nbsp;
              {price}
              &nbsp;
              {planItem.currentPlanByLang.unit}
            </span>
          </h3>
          <span className="subscription__price">
            {pricePerImage} {planItem.currentPlanByLang.unit}{' '}
            <span className="subscription__price-month">
              /{this.props.t('image')}
            </span>{' '}
          </span>
          <div className={`subscription_button_select ${Config.serviceType}`}>
            {this.props.t('extra_license_register_modal_select_button')}
          </div>
        </label>
      </>
    );
  };

  handleSubmitExtraLicense = (result) => {
    const { handleSubmit } = this.props;
    window.scrollTo(0, 0);
    handleSubmit(result);
  };

  render() {
    const { agree, pristine, submitting, handleSubmit } = this.props;
    const { t, el_plans } = this.props;
    return (
      <form className="extra-license-register-form">
        <div className="header">
          <h2 className="header__title">
            {t('extra_license_rigister_modal_title')}
          </h2>
          <p className="header__text">
            {t('extra_license_rigister_modal_sub_title')}
          </p>
        </div>
        <div className="extra-license-plans">
          {el_plans.map((plan, index) => {
            if (index == 1) {
              return this.renderExtraPlanItem(
                this.buildExtraLicensePlan(plan, true),
                index,
              );
            }

            return this.renderExtraPlanItem(
              this.buildExtraLicensePlan(plan, false),
              index,
            );
          })}
        </div>
        <div className="extra-license-merit">
          <p className="extra-license-merit-title">
            {t('extra_license_rigister_modal_question')}
          </p>
          <ul className="subscription__list">
            <li className="subscription__item">
              <span>
                <FontAwesomeIcon
                  className="icon-large icon-subscription"
                  style={{ width: '1em' }}
                  icon={faCheckCircle}
                />
                {t('extra_license_benefit_1')}{' '}
              </span>
            </li>
            <li className="subscription__item">
              <span>
                <FontAwesomeIcon
                  className="icon-large icon-subscription"
                  style={{ width: '1em' }}
                  icon={faCheckCircle}
                />
                {t('extra_license_benefit_2')}
              </span>
            </li>
          </ul>
        </div>
        <div className="extra-license-term">
          <label>
            <Field
              name="agree"
              id="employed"
              title={t('extra_license_rigister_modal_agree_term')}
              component={renderCheckboxField}
              type="checkbox"
            />
          </label>
          <div>
            <Link href="/terms-extra-license">
              <a className={`color-${Config.serviceType}`}>
                {t('extra_license_rigister_modal_term_link')}
              </a>
            </Link>
          </div>
        </div>
        <div className="extra-license-sub-button">
          <button
            disabled={!agree || pristine || submitting}
            className={`btn btn-ac-primary btn-${Config.serviceType} extra-license-register-button`}
            onClick={this.handleSubmitExtraLicense}
          >
            <FontAwesomeIcon className="icon-large" icon={faAward} />{' '}
            {t('extra_license_rigister_modal_subscribe_button')}
          </button>
        </div>
        <div className="extra-license-register-term">
          <p>{t('extra_license_rigister_modal_notice')}</p>
          <p
            dangerouslySetInnerHTML={{
              __html: t('auto_renewal_extra_license_pack'),
            }}
          />
        </div>
      </form>
    );
  }
}

let ExtraLicenseForm = reduxForm({
  form: 'ExtraLicenseRegisterForm',
})(ExtraLicenseRegisterForm);

const selector = formValueSelector('ExtraLicenseRegisterForm');
ExtraLicenseForm = connect((state) => {
  const agree = selector(state, 'agree');
  return { agree };
})(ExtraLicenseForm);

export default ExtraLicenseForm;
